import React from 'react';
import { getLabelEstadoById } from "../../../helper/ordenHelper";
import { formatoFechaSinHora } from "../../../utilities/formatoFecha";

export default function EstadoListItem({ idEstado, fecha, children }) {
  return (
    <div className="row align-items-center text-center mb-0 mb-lg-2">
      <div className="col-12 col-sm-2">
        <span className={`label label-${getLabelEstadoById(idEstado).color}`}>
          {getLabelEstadoById(idEstado).label}
        </span>
      </div>
      <div className="col-12 col-sm-2">
        <p className="d-inline">{formatoFechaSinHora(fecha)}</p>
      </div>
      {children}
    </div>
  )
}